import React, { useContext } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { ConfigContext } from '../../../context/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';


import NavLogo from './NavLogo';
import NavContent from './NavContent';
import navigation from '../../../menu-items';

const Navigation = () => {
  const configContext = useContext(ConfigContext);
  const { collapseMenu } = configContext.state;
  const windowSize = useWindowSize();

  let navClass = ['pcoded-navbar'];

  navClass = [...navClass];

  if (windowSize.width < 992 && collapseMenu) {
    navClass = [...navClass, 'mob-open'];
  } else if (collapseMenu) {
    navClass = [...navClass, 'navbar-collapsed'];
  }

  let navBarClass = ['navbar-wrapper'];

  const { user } = useAuth(); // ✅ Get user from context
  const role = user?.role?.toLowerCase();
  console.log(role);

  const filterMenuItemsByRole = (items, role) => {
    if (role === 'super_admin' || role === 'super admin' || role === 'admin') return items;
    return items
      .map(item => {
        const hasRole = !item.roles || item.roles.includes(role);

        if (item.children) {
          const filteredChildren = filterMenuItemsByRole(item.children, role);
          if (hasRole || filteredChildren.length > 0) {
            return { ...item, children: filteredChildren };
          }
          return null;
        }

        return hasRole ? item : null;
      })
      .filter(Boolean); // Remove nulls
  };

  const filteredMenuItems = filterMenuItemsByRole(navigation.items, role);

  let navContent = (
    <div className={navBarClass.join(' ')}>
      {/* <NavLogo /> */}
      <NavContent navigation={filteredMenuItems} />
    </div>
  );
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        {/* <NavLogo /> */}
        <NavContent navigation={filteredMenuItems} />

      </div>
    );
  }
  return (
    <React.Fragment>
      <nav className={navClass.join(' ')}>{navContent}</nav>
    </React.Fragment>
  );
};

export default Navigation;
